import { TPadding, TFontSize, TMisc } from '@com/core/common/types/styles/baseStyles';

// --- Breakpoints
const xsMin = 480;
const smMin = 768;
const mdMin = 992;
const lgMin = 1200;
const xlMin = 1366;

const bp = {
    xsMin,
    smMin,
    mdMin,
    lgMin,
    xlMin,
    xsMax: xsMin - 1,
    smMax: smMin - 1,
    mdMax: mdMin - 1,
    lgMax: lgMin - 1,
};

export const breakpoints = {
    minMobile: `only screen and (min-width: ${bp.xsMin}px)`,
    minTablet: `only screen and (min-width: ${bp.smMin}px)`,
    minDesktop: `only screen and (min-width: ${bp.mdMin}px)`,
    minDesktopLG: `only screen and (min-width: ${bp.lgMin}px)`,
    minDesktopXLG: `only screen and (min-width: ${bp.xlMin}px)`,

    maxMobile: `only screen and (max-width: ${bp.xsMax}px)`,
    maxTablet: `only screen and (max-width: ${bp.smMax}px)`,
    maxDesktop: `only screen and (max-width: ${bp.mdMax}px)`,
    maxDesktopLG: `only screen and (max-width: ${bp.lgMax}px)`,
};

// --- Spacing
export const padding: TPadding = {
    xsWrapperPadding: '10px',
    smWrapperPadding: '12px',
    mdWrapperPadding: '15px',
    lgWrapperPadding: '25px',
};

// --- Fonts
export const fontSize: TFontSize = {
    smBase: '12px',
    mdBase: '13px',
};

// --- Misc
export const misc: TMisc = {
    minWidth: '768px',
    maxWidth: '1440px',
    maxWidthXL: '1920px',
    productImageRatio: '136.375%',
    siteHeaderHeightDesktop: '65px',
    siteHeaderHeightMobile: '54px',
    supportBarHeight: '38px',
    mobileSearchHeight: '37px',
};

// --- !!! Needs a cleanup
export const resetStyles = `
    html, body, div, span, applet, object, iframe,
    h1, h2, h3, h4, h5, h6, p, blockquote, pre,
    a, abbr, acronym, address, big, cite, code,
    del, dfn, em, img, ins, kbd, q, s, samp,
    small, strike, strong, sub, sup, tt, var,
    b, u, i, center,
    dl, dt, dd, ol, ul, li,
    fieldset, form, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside, canvas, details, embed,
    figure, figcaption, footer, header, hgroup,
    menu, nav, output, ruby, section, summary,
    time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
        box-sizing: border-box;
    }

    article, aside, details, figcaption, figure,
    footer, header, hgroup, menu, nav, section {
        display: block;
    }

    ol, ul {
        list-style: none;
    }

    blockquote, q {
        quotes: none;
    }

    blockquote:before, blockquote:after,
    q:before, q:after {
        content: '';
        content: none;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
    }

    * {
        box-sizing: border-box;
    }

    html {
        font-size: ${fontSize.smBase};
    }

    @media ${breakpoints.minDesktop} {
        html{
            font-size: ${fontSize.mdBase};
        }
    }

    body {
        min-height: 100vh;
    }

    body.locked {
      overflow: hidden;
    }

    strong, b {
        font-weight: bold;
    }

    a {
        text-decoration: none;
        cursor: pointer;
        color: inherit;
    }

    *:focus {
        outline: none;
    }

    img {
      max-width: 100%;
      display: block;
    }

    input, button, textarea, select {
        font: inherit;
        color: inherit;
        padding: 0;
        margin: 0;
        border: 0;
        box-sizing: border-box;
        border-radius: 0;
    }

    input, textarea, select  {
        border: 1px solid #e4f7db;
        font-size: 16px;
    }

    @media ${breakpoints.minDesktop} {
        input, textarea, select  {
            font-size: 1rem;
        }
    }

    input ::-ms-clear {
      display: none;
    }

    button {
        background-color: transparent;
        cursor: pointer;
    }

    button[disabled] {
      cursor: default;
    }

    * {
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -webkit-tap-highlight-color: transparent;
    }
`;
